export default function SafetyCommitment() {
  return (
    <section className="py-20 bg-[#2C2C2C]">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <div className="w-20 h-20 flex items-center justify-center bg-[#C5A55A] rounded-full mx-auto mb-8">
          <i className="ri-shield-check-fill text-4xl text-white"></i>
        </div>
        <h2 className="text-4xl font-bold text-[#C5A55A] mb-8">
          Safety Is Our Foundation
        </h2>
        <p className="text-xl text-gray-300 leading-relaxed">
          At Deer Point Contracting, safety is not negotiable. We are committed to maintaining a zero-incident jobsite culture through rigorous training, OSHA compliance, and daily safety protocols. Every team member, subcontractor, and trade partner on our sites goes home safe at the end of every day.
        </p>
      </div>
    </section>
  );
}